import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebook, 
  FaInstagram, 
  FaTwitter, 
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaTruck,
  FaShieldAlt,
  FaUndo,
  FaHeadset,
  FaStar,
  FaArrowRight,
  FaFire
} from 'react-icons/fa';

const Footer = () => {
  const quickLinks = [
    { name: 'About Us', to: '/about' },        
    { name: 'Refer & Earn', to: '/referearn' },   
     { name: 'Frame Size', to: '/frame-size', icon: <FaShieldAlt className="text-xs" /> }, 
  ];

  const services = [
    { name: 'Store Locator', to: '/stores', icon: <FaMapMarkerAlt className="text-xs" /> },
    { name: 'Buying Guide', to: '/buying-guide', icon: <FaHeadset className="text-xs" /> }, 
    { name: 'Contact Us', to: '/contact', icon: <FaPhone className="text-xs" /> }
  ];

  const helpLinks = [
    { name: 'FAQ', to: '/faq' },
    { name: 'Grievance Redressal', to: '/grievance' },
    { name: 'Track Order', to: '/track-order' },
    { name: 'Returns', to: '/returns' }
  ];

  const socialLinks = [
    { icon: <FaFacebook />, href: 'https://facebook.com/brframes', color: 'hover:text-orange-500', bg: 'bg-orange-500/10' },
    { icon: <FaInstagram />, href: 'https://instagram.com/brframes', color: 'hover:text-orange-500', bg: 'bg-orange-500/10' },
    { icon: <FaTwitter />, href: 'https://twitter.com/brframes', color: 'hover:text-orange-500', bg: 'bg-orange-500/10' },
    { icon: <FaLinkedin />, href: 'https://linkedin.com/company/brframes', color: 'hover:text-orange-500', bg: 'bg-orange-500/10' }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white border-t border-orange-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            {/* Logo from public folder */}
            <Link to="/" className="block mb-4">
              <img 
                src="/logo1.png" 
                alt="BRframes Logo" 
                className="h-10 md:h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Premium Eyewear Frames Manufacturer & Supplier. Crafting excellence in every frame.
            </p>
            <div className="flex gap-2">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-8 h-8 ${social.bg} rounded-lg flex items-center justify-center text-gray-400 ${social.color} hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-110`}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4 flex items-center gap-2">
              <span className="w-1 h-4 bg-orange-500 rounded-full"></span>
              About Us
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.to} 
                    className="text-sm text-gray-400 hover:text-orange-500 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <FaArrowRight className="text-[8px] text-orange-500 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4 flex items-center gap-2">
              <span className="w-1 h-4 bg-orange-500 rounded-full"></span>
              Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link 
                    to={service.to} 
                    className="text-sm text-gray-400 hover:text-orange-500 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <span className="text-orange-500 group-hover:scale-110 transition-transform">
                      {service.icon}
                    </span>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4 flex items-center gap-2">
              <span className="w-1 h-4 bg-orange-500 rounded-full"></span>
              Help
            </h4>
            <ul className="space-y-3">
              {helpLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.to} 
                    className="text-sm text-gray-400 hover:text-orange-500 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <FaArrowRight className="text-[8px] text-orange-500 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 py-6 border-t border-gray-800">
          <div className="flex items-center gap-4 text-sm">
            <a href="tel:18001234567" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors group">
              <FaPhone className="text-orange-500 group-hover:scale-110 transition-transform" />
              <span>9709799555</span>
            </a>
            <span className="text-gray-700">|</span>
            <a href="mailto:info@brframes.com" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors group">
              <FaEnvelope className="text-orange-500 group-hover:scale-110 transition-transform" />
              <span>info@brframes.com</span>
            </a>
          </div>
          <div className="flex gap-3">
            <a 
              href="#" 
              className="bg-gray-800 px-5 py-2.5 rounded-lg text-sm text-white hover:bg-orange-500 transition-all duration-300 transform hover:scale-105 flex items-center gap-2 group"
            >
              <span>📱</span>
              <span>Google Play</span>
              <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
            </a>
            <a 
              href="#" 
              className="bg-gray-800 px-5 py-2.5 rounded-lg text-sm text-white hover:bg-orange-500 transition-all duration-300 transform hover:scale-105 flex items-center gap-2 group"
            >
              <span></span>
              <span>App Store</span>
              <FaArrowRight className="text-xs opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
            </a>
          </div>
        </div>
        <div className="relative pt-6 mt-6 border-t border-gray-800/50">
          <div className="absolute -top-[1px] left-1/2 transform -translate-x-1/2 w-20 h-[2px] bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
          
          <div className="text-center text-xs text-gray-600">
            <p>© 2024 BRframes. Premium Eyewear Frames Manufacturer & Supplier. All rights reserved.</p>
          </div>
          <div className="flex justify-center items-center gap-3 mt-4">
            <div className="w-1 h-1 bg-orange-500/50 rounded-full animate-pulse"></div>
            <div className="w-1 h-1 bg-orange-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-1 h-1 bg-orange-500/50 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;